import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, MessageSquareText } from "lucide-react";
import { SITE, SOLUTIONS } from "@/data/site";
import { Logo } from "@/components/layout/Header";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="et-navy-band text-slate-300">
      <div className="et-container py-14 lg:py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 lg:gap-10">
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="inline-flex items-center rounded-xl bg-white px-3 py-2 shadow-sm" aria-label="E Telecom home">
              <img src="/etelecom-logo.png" alt="E Telecom logo" className="h-9 w-auto object-contain" width="140" height="40" />
            </Link>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-xs">
              Business communication and automation solutions — WhatsApp, SMS and smart telephony for businesses that communicate at scale.
            </p>
          </div>

          <FooterCol title="Solutions">
            {SOLUTIONS.map((s) => (
              <FooterLink key={s.slug} to={s.path}>{s.title}</FooterLink>
            ))}
          </FooterCol>

          <FooterCol title="Company">
            <FooterLink to="/about">About Us</FooterLink>
            <FooterLink to="/contact">Contact</FooterLink>
            <FooterLink to="/pricing">Pricing</FooterLink>
            <FooterLink to="/#faq">FAQs</FooterLink>
          </FooterCol>

          <FooterCol title="Resources">
            <FooterLink to="/contact">Blog <Soon /></FooterLink>
            <FooterLink to="/contact">Documentation <Soon /></FooterLink>
            <FooterLink to="/contact">API <Soon /></FooterLink>
            <FooterLink to="/contact">Support</FooterLink>
          </FooterCol>

          <FooterCol title="Get in touch">
            <a href={`tel:${SITE.phone}`} className="flex items-start gap-2.5 text-sm text-slate-400 hover:text-white transition-colors">
              <Phone className="h-4 w-4 mt-0.5 shrink-0" /> {SITE.phoneDisplay}
            </a>
            <a href={`mailto:${SITE.email}`} className="flex items-start gap-2.5 text-sm text-slate-400 hover:text-white transition-colors">
              <Mail className="h-4 w-4 mt-0.5 shrink-0" /> {SITE.email}
            </a>
            <span className="flex items-start gap-2.5 text-sm text-slate-400">
              <MapPin className="h-4 w-4 mt-0.5 shrink-0" /> {SITE.address}
            </span>
          </FooterCol>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-400">© 2026 E Telecom. All Rights Reserved.</p>
          <div className="flex items-center gap-6 text-xs">
            <Link to="/privacy-policy" className="text-slate-400 hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-slate-400 hover:text-white transition-colors">Terms &amp; Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

const Soon = () => (
  <span className="ml-1.5 rounded-full bg-white/10 px-1.5 py-0.5 text-[9px] font-medium text-slate-300 align-middle">Soon</span>
);

const FooterCol = ({ title, children }) => (
  <div>
    <h4 className="font-display text-sm font-semibold text-white mb-4">{title}</h4>
    <div className="flex flex-col gap-3">{children}</div>
  </div>
);

const FooterLink = ({ to, children }) => (
  <Link to={to} className="text-sm text-slate-400 hover:text-white transition-colors">
    {children}
  </Link>
);
